
import React from 'react';
import { DateRange } from "react-day-picker";
import { DateRangePicker } from "@/components/dashboard/DateRangePicker";

interface DashboardHeaderProps {
  dateRange: DateRange | undefined;
  onDateRangeChange: (newDateRange: DateRange | undefined) => void;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({ 
  dateRange, 
  onDateRangeChange 
}) => {
  return (
    <header className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div>
        <h1 className="text-2xl font-bold">Dashboard</h1>
        <p className="text-gray-500">Visão geral dos resultados da sua loja.</p>
      </div>
      <DateRangePicker 
        dateRange={dateRange} 
        onDateRangeChange={onDateRangeChange} 
      />
    </header>
  );
};

export default DashboardHeader;
